import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Civility';
const ENDPOINT = `/civilities/`;

@Injectable({
    providedIn: 'root'
})
export class CivilityService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
